import React, { useState, useEffect } from "react";
import { Container, Col, Image, Row, Card } from "react-bootstrap";
import { IPUrl } from "../commons/IPAddress";
import { NavLink, useParams } from 'react-router-dom'
import AllHeader from "../components/AllHeader";
import NotInfo from "../components/NotInfo";
import useCheckUser from "../custom-hooks/useCheckUser";
import { toast } from "react-toastify";
import axiosInstance from "../api/axiosInstance";
import BigLoader from "../components/BigLoader";


function Places() {
  const [load, setLoad] = useState(false);
  const [seenFile, setSeenFile] = useState([]);
  const UserID = localStorage.getItem("UserId");
  const params = useParams()


    // Example usage of the custom hook
    useCheckUser(UserID); // Replace UserID with the actual user ID value

  useEffect(() => {
      setLoad(true)
      axiosInstance.post("GetPlaceList", {
        type: params.placesId,
      }
      ).then((res) => {
        if (res.data.result === "true") {
          setSeenFile(res.data.data)
          setLoad(false)
        } else {
          toast.error(res.data.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        }
      });
  }, [params.placesId]);

  return (
    <div className="rgc-pages">
      <AllHeader>
        {(() => {
          switch (params.placesId) {
            case '1':
              return (<span>اماکن گردشگری</span>)
            case '2':
              return (<span>اماکن مذهبی</span>)
            default:
              return (<span> اماکن</span>)
          }

        })()
        }
      </AllHeader>
      <Container>
        <Row className="justify-content-start">

          {load === false && seenFile.length === 0 ?
            <NotInfo />
            :
            seenFile.map((data, index) => {
              return (
                <Col xs={12} sm={6} lg={4} className="rgc-news-item" key={index}>
                  <NavLink to={"/Internalplaces/" + data.Id} state={data.Tittle}>
                    <Card className="rgc-news">
                      <Row>
                        <Col xs={5} className="rgc-img-news">
                          <Image src={IPUrl + "/UploadedFile/Places/Ssn/" + data.Pic} alt="" fluid />
                        </Col>
                        <Col xs={7} className="rgc-text-news">
                          {data.Tittle.length > 60 ? <p>{data.Tittle.substring(0, 60) + "..."}</p> : <p>{data.Tittle} </p>}
                          {data.Chekideh.length > 60 ? <p><i className="fa fa-map-marker-alt rgc-text-icon" aria-hidden="true"  ></i><br />{data.Chekideh.substring(0, 60) + "..."}</p> : <p><i className="fa fa-map-marker-alt rgc-text-icon" aria-hidden="true"  ></i><br />{data.Chekideh} </p>}
                        </Col>
                      </Row>
                    </Card>
                  </NavLink>
                </Col>

              )
            })
          }
        </Row>
      </Container>
      <BigLoader loading={load} />
    </div>
  );
}

export default Places;
